import React from 'react';
import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';
import DrugImage from '../../molecules/DrugImage';

const DrugImageView: React.FC<NodeViewProps> = ({ node, extension }) => {
  const itemCode = node.attrs.itemCode;

  if (!itemCode) {
    return null;
  }

  // drugsData, pillsData를 options에서 가져오기
  const drugsData = (extension.options as any).drugsData;
  const pillsData = (extension.options as any).pillsData;

  return (
    <NodeViewWrapper
      as="div"
      style={{ display: 'block' }}
      contentEditable={false}
    >
      <DrugImage
        itemCode={itemCode}
        drugsData={drugsData}
        pillsData={pillsData}
        width={100}
        enableHoverZoom={true}
        zoomScale={4}
      />
    </NodeViewWrapper>
  );
};

export default DrugImageView;
